import { toDollars } from '@pelicargo/utils';

import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';

type SurchargeOutput = TrpcOutputs['getSurcharges'][1];

export type FormattedSurcharge = Omit<SurchargeOutput, 'origin_airports' | 'destination_airports'> & {
  origin_airports: string[];
  destination_airports: string[];
};

export const useSurcharges = (queryParams: TrpcInputs['getSurcharges']) => {
  const initQuery = trpc.getSurcharges.useQuery(queryParams, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  });

  const formatData = (data: (typeof initQuery)['data'][1]) =>
    data?.map((item) => ({
      ...item,
      min_cost: toDollars(item?.min_cost),
      per_unit_cost: toDollars(item?.per_unit_cost),
      origin_airports: item?.origin_airports?.map((airport) => airport.airport_as_origin_id),
      destination_airports: item?.destination_airports?.map((airport) => airport.airport_as_destination_id),
    }));

  const isLoading = Boolean(initQuery.isLoading);
  const items = formatData(initQuery.data?.[1]);
  const itemCount = initQuery?.data?.[0];

  return {
    data: items,
    count: itemCount,
    isLoading,
    error: initQuery?.error?.message,
    refetch: initQuery.refetch,
  };
};
